import api from './index';

export const exchangeAPI = {
  getProducts: (params) => {
    return api.get('/api/exchange/products', { params });
  },
  getProductDetail: (id) => {
    return api.get(`/api/exchange/products/${id}`);
  },
  createOrder: (data) => {
    return api.post('/api/exchange/orders', data);
  },
  getOrders: (params) => {
    return api.get('/api/exchange/orders', { params });
  },
  getOrderDetail: (id) => {
    return api.get(`/api/exchange/orders/${id}`);
  }
};